<template>
  <p class="h1 text-center">Contactame</p>
  <div class="d-flex justify-content-center">
    <div class="card m-4" style="width: 18rem;">
      <img src="../assets/linkedInPhoto.jpeg" class="card-img-top p-1 border" title="Jose Arpaia" alt="Jose Arpaia">
      <div class="card-body">
        <p class="card-title h1">Jose Arpaia</p>
        <p class="card-text">Web Developer</p>
        <a href="https://josearpaiaq.netlify.app/" target="blank" class="btn btn-outline-success">Web Site</a>
      </div>
    </div>
  </div>
</template>
